import React from "react";
import { getLanguage, setLanguage, t } from "../i18n";

type Props = {
    className?: string,
}

export default function LanguageSwitcher({ className }: Props) {
    const currentLanguage = getLanguage();
    const nextLanguage = currentLanguage === 'vi' ? 'en' : 'vi';

    return (
        <button
            type="button"
            className={className ?? "btn btn-outline-light waves-effect"}
            onClick={() => setLanguage(nextLanguage)}
            title={currentLanguage === 'vi' ? t('header.switchToEnglish') : t('header.switchToVietnamese')}
        >
            {nextLanguage === 'en' ? t('language.english') : t('language.vietnamese')}
        </button>
    );
}